const sliderTestimonial = () => {
    const sections = document.querySelectorAll('.slider-testimonial');
    if (!sections.length) return;

    sections.forEach(section => {
        const slider = section.querySelector('.slider-testimonial__swiper');
        if (!slider) return;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: section.querySelector('.slider-testimonial__pagination'),
                type: 'fraction',
            },
            navigation: {
                prevEl: section.querySelector('.slider-testimonial__btn-prev'),
                nextEl: section.querySelector('.slider-testimonial__btn-next'),
            },
        });
    });
};

export default sliderTestimonial;
